export default "__VITE_ASSET__512e192f__"